export const queryItems = <T>(
  query: string,
  items: T[],
  propertyRetriever: (item: T) => string,
): T[] =>
  items.filter((item) => propertyRetriever(item).toLowerCase().includes(query.toLowerCase()));
